import {
  Button, SidebarModal,
} from '@domain-group/suit-theme'

import EntityActivity from '@components/EntityActivity'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalPayload = {
  conversationTitle?: string,
  subjectId?: number,
  subjectType?: string,
  title?: string,
  titleSecondLine?: string,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  payload: ModalPayload,
  showModal: boolean,
}

const ManageEntityActivityModal = (props: ModalProps) => {
  const { callbacks, payload, showModal } = props
  const { closeModal } = callbacks

  const {
    conversationTitle,
    subjectId,
    subjectType,
    title = 'Comments &',
    titleSecondLine = 'Activity',
  } = payload || {}

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey="ManageEntityActivityModal" showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title={title} titleSecondLine={titleSecondLine} />

      <SidebarModal.Content>
        {/* @ts-expect-error TS2741 */}
        <EntityActivity
          componentSettings={{
            conversation: {
              title: conversationTitle,
            },
          }}
          subjectType={subjectType}
          subjectId={subjectId}
        />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button buttonStyle="secondaryUtility" onClick={() => closeModal()} size="large">
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  // @ts-expect-error TS2786
  <SidebarModal.RenderController {...props}>
    <ManageEntityActivityModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
